import React from 'react';
import styled from 'styled-components';
import {SIZES, Line, Typography} from '@fupa/fupa-uikit';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 100%;
`;

const Container = styled.div`
  display: flex;
  padding: ${SIZES['12']} ${SIZES['16']};
`;

const Season = styled(Typography)`
  flex: 1 20%;
`;

const League = styled(Typography)`
  flex: 1 70%;
`;

const Rank = styled(Typography)`
  text-align: right;
  flex: 1 10%;
`;

const TeamHistoryRow = ({season}) => {
  if (season.competition) {
    return (
      <Content>
        <Container>
          <Season variant='body1'>{season.competition.season.name}</Season>
          <League variant='body1'>{season.competition.name}</League>
          <Rank variant='body1'>{season.rank}</Rank>
        </Container>
        <Line />
      </Content>
    );
  } else {
    return null;
  }
};

export default TeamHistoryRow;
